import { render } from "./SimpleMode.vue?vue&type=template&id=d3b6d086&scoped=true"
import script from "./SimpleMode.vue?vue&type=script&lang=js"
export * from "./SimpleMode.vue?vue&type=script&lang=js"

import "./SimpleMode.vue?vue&type=style&index=0&id=d3b6d086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b6d086"]])

export default __exports__